import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { ModuleWithProviders, NgModule, Optional, SkipSelf } from '@angular/core';

import { AlliancesServicesService } from '@am/alliance-service';
import { DateService } from '@services/date.service';
import { HFService } from '@services/hf.service';
import { LandingService } from '@services/landing.service';
import { PriceService } from '@services/price.service';
import { SearchService } from '@services/search.service';
import { TranslateService } from '@services/translate.service';
import { UrlService } from '@services/url.service';
import { AlliancesService } from '@services/alliances.service';
import { Ga4Service } from '@services/ga4.service';
import { TrivagoService } from '@services/trivago.service';

@NgModule({
  declarations: [],
  imports: [],
  providers: [
    DateService,
    HFService,
    SearchService,
    LandingService,
    TranslateService,
    UrlService,
    PriceService,
    AlliancesServicesService,
    AlliancesService,
    Ga4Service,
    TrivagoService,
    { provide: 'APP_CONTEXT_TOKEN', useValue: { ...(window as any)._app_context } },
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class CoreModule {
  constructor(
    @Optional()
    @SkipSelf()
    parentModule: CoreModule,
  ) {
    if (parentModule) {
      throw new Error('CoreModule is already loaded, import it only in the AppModule');
    }
  }

  public static forRoot(): ModuleWithProviders<CoreModule> {
    return {
      ngModule: CoreModule,
      providers: [],
    };
  }
}
